import React, { useState } from 'react';
import blur544 from './images/blur-544.png';
import blur830 from './images/blur-830.png';
import blur1310 from './images/blur-1310.png';
import blur1630 from './images/blur-1630.png';
import blur1950 from './images/blur-1950.png';
import notification from './images/notification-in-circle.svg';
import { Button } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

type ConfirmationProps = {
    className?: string;
    onApproveClick?: Function;
    title?: string;
    message?: JSX.Element;
};

const ConfirmationWrapper = styled.div`
    background-size: 100% auto;
    width: 100%;
    height: 100vh;
    font-family: 'Graphik LCG', sans-serif;
    font-size: 14px;
    color: #263238;

    @media (min-width: 0) {
        background-image: url(${blur544});
    }
    @media (min-width: 600px) {
        background-image: url(${blur830});
    }
    @media (min-width: 900) {
        background-image: url(${blur1310});
    }
    @media (min-width: 1400px) {
        background-image: url(${blur1630});
    }
    @media (min-width: 1700px) {
        background-image: url(${blur1950});
    }
`;

const Dropdown = styled.div`
    width: 100%;
    padding: 40px 16px 23px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 8px -2px rgba(38, 50, 56, 0.12), 0 1px 1px 0 rgba(38, 50, 56, 0.04);
    background-color: #ffffff;
    position: absolute;
    bottom: 0;
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 33px;
`;

const ButtonWrapper = styled(Button)`
    display: flex;
    flex-grow: 1;
    height: 40px;
    margin-right: 14px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    box-shadow: 0 1px 4px 0 rgba(38, 50, 56, 0.08), 0 1px 1px 0 rgba(38, 50, 56, 0.04);
    background-color: #ff9d00;
    font-weight: 500;
    color: #ffffff;
    &:last-child {
        margin-right: 0px;
    }
    &.ant-btn:hover,
    &.ant-btn:focus {
        border-color: #ff9d00;
        color: #ff9d00;
    }
`;

const TitleWrapper = styled.div`
    font-weight: 500;
    color: #263238;
`;

const ImageWrapper = styled.img`
    margin-right: 14px;
`;

export const Confirmation = (initial: ConfirmationProps) => {
    const [legalProps] = useState<ConfirmationProps | null>(initial);
    // eslint-disable-next-line
    const { t, i18n } = useTranslation('common');

    if (legalProps === null) return null;

    return (
        <ConfirmationWrapper className={legalProps.className}>
            <Dropdown>
                <MessageContainer>
                    <ImageWrapper src={notification} alt='notification' />
                    <div>
                        {legalProps.title && <TitleWrapper>{legalProps.title}</TitleWrapper>}
                        {legalProps.message && legalProps.message}
                    </div>
                </MessageContainer>
                {legalProps.onApproveClick && (
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <ButtonWrapper onClick={legalProps.onApproveClick}>{t('Continue')}</ButtonWrapper>
                    </div>
                )}
            </Dropdown>
        </ConfirmationWrapper>
    );
};
